module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-popular-e7bf005a03f1b45dfbc30ae832eea96e.svg";